import { makeStyles } from 'tss-react/mui';

const useStylesGrid: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  gridStretched: {
    alignItems: 'stretch',
  },
  gridSpread: {
    justifyContent: 'space-between',
  },
  gridCentered: {
    justifyContent: 'center',
  },
  gridEnd: {
    justifyContent: 'flex-end',
  },
}));

export default useStylesGrid;
